// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectChatMessages_container__1iXgV","hidden":"ProjectChatMessages_hidden__1ntgZ","errorWrapper":"ProjectChatMessages_errorWrapper__3J_DS"};